var _metadata, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    enableBackground: "new 0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, " Svg Vector Icons : http://www.onlinewebfonts.com/icon ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M127.7,10c-33.9,0-59.5,27-59.5,62.8v22.1h-1.9C48.5,94.8,34,109.7,34,128v84.8c0,18.3,14.5,33.2,32.3,33.2h123.3c17.8,0,32.3-14.9,32.3-33.2V128c0-18.3-14.5-33.2-32.3-33.2h-1.1c-0.3-0.1-0.6-0.1-0.9-0.2V72.8C187.7,37,161.9,10,127.7,10z M127.7,19.8c29.1,0,50.2,22.3,50.2,52.9v21.7H78.1V72.8C78.1,42.1,99,19.8,127.7,19.8z M212.1,128v84.8c0,12.9-10.1,23.4-22.5,23.4H66.3c-12.4,0-22.5-10.5-22.5-23.4V128c0-12.9,10.1-23.4,22.5-23.4h11.8v-0.3h99.8v0.3h11.8C202.1,104.7,212.1,115.1,212.1,128z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M126.9,141.2c-7.9,0-14.3,6.6-14.3,14.7c0,5.4,2.9,10.2,7.1,12.7v24c0,4.1,3.2,7.4,7.1,7.4s7.1-3.3,7.1-7.4v-24c4.3-2.6,7.1-7.3,7.1-12.7C141.1,147.8,134.8,141.2,126.9,141.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginPassword);
export default __webpack_public_path__ + "static/media/Login_password.f8b59443fe5852b2cccab554d33091ed.svg";
export { ForwardRef as ReactComponent };